import React, { useState } from "react";
import {
    Button,
} from "@material-ui/core";
import { getLocalizedString } from "@icarius-localization/strings";
import Container from "../../../container";
import TextEditor from "@icarius-common/textEditor";
import { useDispatch } from "react-redux";
import { updateNotesFromTrainingAction } from "@icarius-pages/myTraining/actions";

const NotesTab = (props) => {

    const {
        trainingData,
        activityData,
    } = props;

    const [value, setValue] = useState(activityData.notes);
    const dispatch = useDispatch();

    const handleSubmit = () => {
        dispatch(updateNotesFromTrainingAction(trainingData.id, activityData.id, { notes: value }));
    }

    return (
        <Container
            style={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-end",
                gap: 10,
            }}
        >
            <div style={{ width: "100%" }}>
                <TextEditor
                    placeholder={getLocalizedString("enterNotes")}
                    disabled={trainingData.isFinished}
                    initialValue={value}
                    handleChange={(value) => setValue(value)}
                    allowImages
                />
            </div>
            <Button
                variant="contained"
                className="whiteText"
                onClick={handleSubmit}
            >
                {getLocalizedString("save")}
            </Button>
        </Container>
    )
}

export default NotesTab;